export const initSchedulePageModals = {
  addScheduleItem: false,
};
